// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "A map displaying live wind, rain radar and/or air quality data, with the ability to focus on any postcode in Australia.";

const CONFIG: InteractivesMenuItemConfig = {
  name: "Live wind, rain radar & air quality map",
  id: "live-wind-rain-radar-map",
  linkPrefix: "/interactives",
  tags: ["Weather", "Configurable", "Map", "Data viz"],
  description,
  image: DisplayImage,
  adminOnly: false,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/wind-rain-radar-air-quality-map/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "LiveWindRainRadarConfigTool" */ "app/components/tools/LiveWindRainRadarAirQualityConfigTool/LiveWindRainRadarAirQualityConfigTool"),
    loading: DynamicImportLoader,
    modules: ["LiveWindRainRadarAirQualityConfigTool"]
  })
};

export default CONFIG;
